import { SET_SEARCH_USER } from '../constants';

export interface SetSearchUserAction {
  type: typeof SET_SEARCH_USER;
  payload: string;
}

export type SearchUserActions = SetSearchUserAction;

export const setSearchUser = (user: string): SetSearchUserAction => ({
  type: SET_SEARCH_USER,
  payload: user,
});
